var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFcnm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318.636,
    height: 41.101,
    viewBox: "0 0 318.636 41.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1008",
    "data-name": "Rect\\xE1ngulo 1008",
    width: 318.636,
    height: 41.101,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_920",
    "data-name": "Grupo 920",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_919",
    "data-name": "Grupo 919",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2704",
    "data-name": "Trazado 2704",
    d: "M76.062,11.2a9.332,9.332,0,1,0,9.332,9.332A9.332,9.332,0,0,0,76.062,11.2m0,15.1a5.767,5.767,0,1,1,5.768-5.768A5.767,5.767,0,0,1,76.062,26.3",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2705",
    "data-name": "Trazado 2705",
    d: "M53.666,11.232A9.332,9.332,0,0,0,44.335,20.5h0V41.1h3.743s-.06-13.111,0-13.066a9.331,9.331,0,1,0,5.589-16.8m0,15.1a5.768,5.768,0,1,1,5.767-5.768,5.767,5.767,0,0,1-5.767,5.768",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2706",
    "data-name": "Trazado 2706",
    d: "M12.565,24.492h0Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2707",
    "data-name": "Trazado 2707",
    d: "M98.718,26.236h0a5.927,5.927,0,0,1-5.927-5.927V0H89.127V20.316h0A9.59,9.59,0,0,0,98.7,29.9h1.622V26.236Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2708",
    "data-name": "Trazado 2708",
    d: "M37.786,13.752a9.324,9.324,0,0,0-9.124-2.281A10.324,10.324,0,0,0,24.6,13.9L12.5,25.374A5.66,5.66,0,0,1,8.98,26.4a5.732,5.732,0,0,1-5.243-4.37l8.386-.117,5.568-5.322a15.752,15.752,0,0,0-1.841-2.618,9.332,9.332,0,1,0-3.912,15.638,9.343,9.343,0,0,0,4.085-2.337L27.717,16.187A5.426,5.426,0,0,1,35.3,16.3a5.768,5.768,0,0,1-5.837,9.605l.054,3.689a9.333,9.333,0,0,0,8.273-15.845M5.267,16.527a5.739,5.739,0,0,1,8.23.1l-2.233,2.108-7.388.031a5.767,5.767,0,0,1,1.391-2.237",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2709",
    "data-name": "Trazado 2709",
    d: "M121.2,10.217v1.471h2.833V13.5H121.2v3.28h-2.075V8.408H124.5v1.809Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2710",
    "data-name": "Trazado 2710",
    d: "M131.355,11.529v5.247h-1.786l-.087-.643a1.86,1.86,0,0,1-1.6.751,2.538,2.538,0,0,1-2.445-2.751,2.541,2.541,0,0,1,2.445-2.746,1.843,1.843,0,0,1,1.46.616v-.474Zm-1.841,2.6a1.033,1.033,0,1,0-1.039,1.078,1.044,1.044,0,0,0,1.039-1.078",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2711",
    "data-name": "Trazado 2711",
    d: "M132.827,14.155a2.711,2.711,0,0,1,2.833-2.723,2.673,2.673,0,0,1,2.532,1.7l-1.617.659a.973.973,0,0,0-.915-.626.978.978,0,1,0,.915,1.339l1.617.66a2.673,2.673,0,0,1-2.532,1.705,2.711,2.711,0,0,1-2.833-2.719",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2712",
    "data-name": "Trazado 2712",
    d: "M139.431,14.711V11.529h2.01v3.035a.6.6,0,0,0,.648.691.621.621,0,0,0,.67-.691V11.529h2v3.182c0,1.318-.915,2.173-2.674,2.173s-2.658-.855-2.658-2.173",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1006",
    "data-name": "Rect\\xE1ngulo 1006",
    width: 2.01,
    height: 8.367,
    transform: "translate(146.512 8.409)",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2713",
    "data-name": "Trazado 2713",
    d: "M153.7,13.006h-.9v3.77h-2v-3.77h-.916V11.529h.916V9.645h2v1.884h.9Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2714",
    "data-name": "Trazado 2714",
    d: "M160.6,11.529v5.247h-1.786l-.087-.643a1.86,1.86,0,0,1-1.6.751,2.538,2.538,0,0,1-2.445-2.751,2.541,2.541,0,0,1,2.445-2.746,1.844,1.844,0,0,1,1.46.616v-.474Zm-1.841,2.6a1.033,1.033,0,1,0-1.04,1.078,1.044,1.044,0,0,0,1.04-1.078",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2715",
    "data-name": "Trazado 2715",
    d: "M168.031,8.408v8.368h-1.786l-.087-.643a1.86,1.86,0,0,1-1.6.751,2.538,2.538,0,0,1-2.445-2.751,2.541,2.541,0,0,1,2.445-2.746,1.844,1.844,0,0,1,1.46.616v-3.6Zm-1.841,5.725a1.033,1.033,0,1,0-1.04,1.078,1.044,1.044,0,0,0,1.04-1.078",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2716",
    "data-name": "Trazado 2716",
    d: "M178.7,8.408v8.368h-1.786l-.087-.643a1.86,1.86,0,0,1-1.6.751,2.538,2.538,0,0,1-2.445-2.751,2.541,2.541,0,0,1,2.445-2.746,1.844,1.844,0,0,1,1.46.616v-3.6Zm-1.841,5.725a1.033,1.033,0,1,0-1.04,1.078,1.044,1.044,0,0,0,1.04-1.078",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2717",
    "data-name": "Trazado 2717",
    d: "M185.682,14.476h-3.465c.082.626.382.893.889.893a.99.99,0,0,0,.947-.566l1.547.642a2.517,2.517,0,0,1-2.494,1.428,2.731,2.731,0,1,1-.093-5.453,2.508,2.508,0,0,1,2.669,2.675Zm-3.453-.98h1.536c-.055-.534-.24-.8-.73-.8s-.725.251-.806.8",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2718",
    "data-name": "Trazado 2718",
    d: "M118.614,26.135a4.3,4.3,0,0,1,7.725-2.6l-1.575,1.183a2.193,2.193,0,0,0-1.852-.948,2.365,2.365,0,0,0,0,4.728,2.193,2.193,0,0,0,1.852-.948l1.575,1.183a4.3,4.3,0,0,1-7.725-2.6",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2719",
    "data-name": "Trazado 2719",
    d: "M127.683,23.166a1.06,1.06,0,0,1,2.12,0,1.06,1.06,0,1,1-2.12,0m.055,1.907h1.994v5.246h-1.994Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2720",
    "data-name": "Trazado 2720",
    d: "M136.717,28.019h-3.465c.082.627.382.894.889.894a.991.991,0,0,0,.947-.567l1.547.643a2.518,2.518,0,0,1-2.494,1.427,2.731,2.731,0,1,1-.093-5.453,2.508,2.508,0,0,1,2.669,2.676Zm-3.453-.98H134.8c-.055-.533-.24-.8-.73-.8s-.725.25-.806.8",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2721",
    "data-name": "Trazado 2721",
    d: "M143.684,27.018v3.3h-2.005v-3a.625.625,0,0,0-.7-.67.735.735,0,0,0-.747.8v2.876h-2.01V25.073h2.01v.659a1.971,1.971,0,0,1,1.591-.757,1.919,1.919,0,0,1,1.863,2.043",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2722",
    "data-name": "Trazado 2722",
    d: "M145.025,27.7a2.712,2.712,0,0,1,2.833-2.724,2.674,2.674,0,0,1,2.532,1.7l-1.617.66a.973.973,0,0,0-.915-.625.977.977,0,1,0,.915,1.338l1.617.66a2.674,2.674,0,0,1-2.532,1.7,2.711,2.711,0,0,1-2.833-2.719",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2723",
    "data-name": "Trazado 2723",
    d: "M151.72,23.166a1.06,1.06,0,0,1,2.119,0,1.06,1.06,0,1,1-2.119,0m.054,1.907h1.994v5.246h-1.994Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2724",
    "data-name": "Trazado 2724",
    d: "M161.2,25.072v5.247h-1.786l-.087-.643a1.861,1.861,0,0,1-1.6.752,2.539,2.539,0,0,1-2.445-2.752,2.54,2.54,0,0,1,2.445-2.745,1.844,1.844,0,0,1,1.46.616v-.475Zm-1.841,2.6a1.033,1.033,0,1,0-1.04,1.079,1.043,1.043,0,0,0,1.04-1.079",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2725",
    "data-name": "Trazado 2725",
    d: "M162.639,29.763l.735-1.264a3.938,3.938,0,0,0,1.732.523c.344,0,.555-.109.555-.288,0-.289-.511-.279-1.318-.5-.746-.213-1.524-.594-1.524-1.586,0-1.182,1.137-1.684,2.385-1.684a4.151,4.151,0,0,1,2.185.578l-.747,1.106a4.257,4.257,0,0,0-1.585-.447c-.256,0-.408.082-.408.224,0,.289.566.37,1.16.512,1.133.283,1.737.691,1.737,1.667,0,1.215-.947,1.825-2.363,1.825a5.245,5.245,0,0,1-2.544-.665",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2726",
    "data-name": "Trazado 2726",
    d: "M180.208,21.951v8.367h-2.185l-3.513-5.224v5.224h-2.075V21.951h2.173l3.525,5.2v-5.2Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2727",
    "data-name": "Trazado 2727",
    d: "M187.806,25.072v5.247H186.02l-.087-.643a1.861,1.861,0,0,1-1.6.752,2.539,2.539,0,0,1-2.445-2.752,2.54,2.54,0,0,1,2.445-2.745,1.844,1.844,0,0,1,1.46.616v-.475Zm-1.841,2.6a1.033,1.033,0,1,0-1.04,1.079,1.043,1.043,0,0,0,1.04-1.079",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2728",
    "data-name": "Trazado 2728",
    d: "M192.992,26.549h-.9v3.77h-2v-3.77h-.916V25.072h.916V23.188h2v1.884h.9Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2729",
    "data-name": "Trazado 2729",
    d: "M194.208,28.254V25.072h2.011v3.036a.6.6,0,0,0,.648.691.621.621,0,0,0,.67-.691V25.072h2v3.182c0,1.318-.915,2.174-2.674,2.174s-2.659-.856-2.659-2.174",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2730",
    "data-name": "Trazado 2730",
    d: "M205.708,25.285l-.681,1.721a1.123,1.123,0,0,0-1.727,1.15v2.162h-2.01V25.072h2.01v.861a1.636,1.636,0,0,1,1.5-.97,1.327,1.327,0,0,1,.9.322",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2731",
    "data-name": "Trazado 2731",
    d: "M212.278,25.072v5.247h-1.786l-.087-.643a1.861,1.861,0,0,1-1.6.752,2.539,2.539,0,0,1-2.445-2.752,2.54,2.54,0,0,1,2.445-2.745,1.844,1.844,0,0,1,1.46.616v-.475Zm-1.841,2.6a1.033,1.033,0,1,0-1.04,1.079,1.043,1.043,0,0,0,1.04-1.079",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1007",
    "data-name": "Rect\\xE1ngulo 1007",
    width: 2.01,
    height: 8.367,
    transform: "translate(214.174 21.952)",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2732",
    "data-name": "Trazado 2732",
    d: "M223.163,28.019H219.7c.082.627.382.894.889.894a.991.991,0,0,0,.947-.567l1.547.643a2.518,2.518,0,0,1-2.494,1.427,2.731,2.731,0,1,1-.093-5.453,2.508,2.508,0,0,1,2.669,2.676Zm-3.453-.98h1.536c-.055-.533-.24-.8-.73-.8s-.725.25-.806.8",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2733",
    "data-name": "Trazado 2733",
    d: "M224.21,29.763l.735-1.264a3.938,3.938,0,0,0,1.732.523c.344,0,.555-.109.555-.288,0-.289-.511-.279-1.317-.5-.747-.213-1.525-.594-1.525-1.586,0-1.182,1.137-1.684,2.385-1.684a4.151,4.151,0,0,1,2.185.578l-.747,1.106a4.257,4.257,0,0,0-1.585-.447c-.256,0-.408.082-.408.224,0,.289.566.37,1.16.512,1.133.283,1.737.691,1.737,1.667,0,1.215-.947,1.825-2.363,1.825a5.245,5.245,0,0,1-2.544-.665",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2734",
    "data-name": "Trazado 2734",
    d: "M239.807,25.073l-3.148,7.866h-2.033l1.046-2.62h-.452l-2.163-5.246h2.185l1.225,3.672,1.286-3.672Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2735",
    "data-name": "Trazado 2735",
    d: "M253.471,21.951v8.367H251.4V25.682l-2.5,3.966-2.474-3.961v4.631h-2.075V21.951h1.841l2.713,4.238,2.74-4.238Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2736",
    "data-name": "Trazado 2736",
    d: "M261.064,25.072v5.247h-1.787l-.087-.643a1.857,1.857,0,0,1-1.6.752,2.539,2.539,0,0,1-2.446-2.752,2.54,2.54,0,0,1,2.446-2.745,1.842,1.842,0,0,1,1.459.616v-.475Zm-1.841,2.6a1.044,1.044,0,0,0-1.041-1.072,1.077,1.077,0,0,0,0,2.151,1.052,1.052,0,0,0,1.041-1.079",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2737",
    "data-name": "Trazado 2737",
    d: "M266.25,26.549h-.9v3.77h-2v-3.77h-.916V25.072h.916V23.188h2v1.884h.9Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2738",
    "data-name": "Trazado 2738",
    d: "M272.7,28.019h-3.465c.082.627.382.894.889.894a.991.991,0,0,0,.947-.567l1.547.643a2.518,2.518,0,0,1-2.494,1.427,2.731,2.731,0,1,1-.093-5.453,2.508,2.508,0,0,1,2.669,2.676Zm-3.453-.98h1.536c-.055-.533-.24-.8-.73-.8s-.725.25-.806.8",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2739",
    "data-name": "Trazado 2739",
    d: "M282.681,27.006v3.313h-2.005V27.274a.553.553,0,0,0-.583-.627c-.478,0-.648.359-.648.757v2.915h-2V27.274a.557.557,0,0,0-.6-.627c-.468,0-.632.359-.632.757v2.915H274.2V25.072h2.01v.594a1.655,1.655,0,0,1,1.368-.691,1.792,1.792,0,0,1,1.559.887,1.819,1.819,0,0,1,1.612-.887,1.9,1.9,0,0,1,1.928,2.031",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2740",
    "data-name": "Trazado 2740",
    d: "M289.99,25.072v5.247H288.2l-.087-.643a1.859,1.859,0,0,1-1.6.752,2.539,2.539,0,0,1-2.445-2.752,2.54,2.54,0,0,1,2.445-2.745,1.844,1.844,0,0,1,1.46.616v-.475Zm-1.841,2.6a1.033,1.033,0,1,0-1.04,1.079,1.043,1.043,0,0,0,1.04-1.079m-1.116-3.126-.72-.8,1.711-1.836.9,1Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2741",
    "data-name": "Trazado 2741",
    d: "M295.177,26.549h-.9v3.77h-2v-3.77h-.916V25.072h.916V23.188h2v1.884h.9Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2742",
    "data-name": "Trazado 2742",
    d: "M296.484,23.166a1.06,1.06,0,0,1,2.119,0,1.059,1.059,0,1,1-2.119,0m.055,1.907h1.994v5.246h-1.994Z",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2743",
    "data-name": "Trazado 2743",
    d: "M300.005,27.7a2.712,2.712,0,0,1,2.833-2.724,2.674,2.674,0,0,1,2.532,1.7l-1.617.66a.973.973,0,0,0-.915-.625.977.977,0,1,0,.915,1.338l1.617.66a2.674,2.674,0,0,1-2.532,1.7,2.711,2.711,0,0,1-2.833-2.719",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2744",
    "data-name": "Trazado 2744",
    d: "M312.289,25.072v5.247H310.5l-.087-.643a1.861,1.861,0,0,1-1.6.752,2.539,2.539,0,0,1-2.445-2.752,2.54,2.54,0,0,1,2.445-2.745,1.844,1.844,0,0,1,1.46.616v-.475Zm-1.841,2.6a1.033,1.033,0,1,0-1.04,1.079,1.043,1.043,0,0,0,1.04-1.079",
    fill: "#3d2977"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2745",
    "data-name": "Trazado 2745",
    d: "M313.728,29.763l.735-1.264a3.938,3.938,0,0,0,1.732.523c.344,0,.555-.109.555-.288,0-.289-.511-.279-1.318-.5-.746-.213-1.524-.594-1.524-1.586,0-1.182,1.137-1.684,2.385-1.684a4.151,4.151,0,0,1,2.185.578l-.747,1.106a4.257,4.257,0,0,0-1.585-.447c-.256,0-.408.082-.408.224,0,.289.566.37,1.16.512,1.133.283,1.737.691,1.737,1.667,0,1.215-.947,1.825-2.363,1.825a5.245,5.245,0,0,1-2.544-.665",
    fill: "#3d2977"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFcnm);
export default __webpack_public_path__ + "static/media/logo-fcnm.7633041bf3d9600b6f3d52d068c281a1.svg";
export { ForwardRef as ReactComponent };